module.exports = __webpack_public_path__ + "img/cyan_circle_happy_smile.23bfe021.png";